import * as React from "react";
export const SilentCheckSSO = () => {
    React.useEffect(() => {
        window.parent.postMessage(window.location.href, window.location.origin);
    }, []);
    return null;
};
